import CarStore from './Car.store'
import HuntStore from './Hunt.store'
import RepairStore from './Repair.store'

const modules = {
  Car: CarStore,
  RepairStore: RepairStore,
  Hunt: HuntStore,
}

export default modules
